import { render, staticRenderFns } from "./camerecord.vue?vue&type=template&id=ed3d7c2a&scoped=true"
import script from "./camerecord.vue?vue&type=script&lang=js"
export * from "./camerecord.vue?vue&type=script&lang=js"
import style0 from "./camerecord.vue?vue&type=style&index=0&id=ed3d7c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d7c2a",
  null
  
)

export default component.exports